import React from 'react';
import ReactDOM from 'react-dom/client';
import './input.css';
import App from './App';
import { MantineProvider } from '@mantine/core';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
     <MantineProvider withNormalizeCSS>
      <App />
    </MantineProvider>
  </React.StrictMode>
);